import { render, staticRenderFns } from "./SLCPage.vue?vue&type=template&id=7e0dfca1&scoped=true"
import script from "./SLCPage.vue?vue&type=script&lang=js"
export * from "./SLCPage.vue?vue&type=script&lang=js"
import style0 from "./SLCPage.vue?vue&type=style&index=0&id=7e0dfca1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e0dfca1",
  null
  
)

export default component.exports